import React from "react";

const DropDownIcon = (props: React.ComponentProps<"svg">) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      strokeWidth="2"
      {...props}
    >
      <path d="m6 9 6 6 6-6" />
    </svg>
  );
};

export default DropDownIcon;
